const initialState = {
  groups: []
};

const groupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOAD_GROUPS':
      return { ...state, groups: action.payload };
    case 'LOAD_GROUP_MEMBERS':
      return {
        ...state,
        // Loose compare: group ids arrive as numbers from the list and can be
        // strings when they come back off a route param.
        groups: state.groups.map(group =>
          // eslint-disable-next-line eqeqeq
          group.id == action.payload.groupId
            ? { ...group, users: action.payload.users }
            : group
        )
      };
    default:
      return state;
  }
};

export default groupsReducer;